"use client";

import { buildYandexMapWidgetUrl } from "@/lib/geo/yandex-map";
import { useLandingResolvedDark } from "@/lib/theme/use-landing-resolved-dark";

type YandexMapEmbedProps = {
  lat: number;
  lon: number;
  zoom: number;
  height: number | "100%";
  title: string;
  className?: string;
  iframeClassName?: string;
};

/**
 * Виджет Яндекс.Карт (iframe map-widget, без API-ключа).
 * Тёмная тема — нативный параметр `theme=dark` у виджета.
 */
export function YandexMapEmbed({
  lat,
  lon,
  zoom,
  height,
  title,
  className = "",
  iframeClassName = "block h-full w-full border-0",
}: YandexMapEmbedProps) {
  const isDark = useLandingResolvedDark();
  const theme = isDark ? "dark" : "light";
  const mapSrc = buildYandexMapWidgetUrl({ lat, lon, zoom, theme });

  const heightStyle =
    height === "100%" ? { height: "100%" } : { height, minHeight: height };

  return (
    <div className={className} style={heightStyle}>
      <iframe
        key={theme}
        title={title}
        src={mapSrc}
        loading="lazy"
        allowFullScreen
        className={iframeClassName}
      />
    </div>
  );
}
